<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="优惠券管理" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button
								size="mini"
								type="primary"
								@click="handleCreate()"
								v-loading="loadings.create"
								>新建</el-button
							>
						</div>
						<div class="operator-col">
							<brand-input v-model="filterBrand"></brand-input>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						:kv-filter="kvFilter"
						@doedit="handleEdit($event)"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
			v-if="editorVisible"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [CurdPage, Filters],

	data() {
		return {
			editorDataModel: "Voucher",
			tableFields: [
				{
					name: "show_id_prefix",
					sortable: "custom",
				},
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "is_active",
					sortable: "custom",
				},
				{
					name: "base_typ",
					sortable: "custom",
				},
				{
					name: "valid_time",
					sortable: "custom",
				},
				{
					name:"limit_value",
					col:6,
				},
				{
					name: "show_value",
					sortable: "custom",
				},
				{
					name: "real_value",
					sortable: "custom",
				},
			],
			editorFields: [
				{
					name: "show_id_prefix",
					col: 6,
				},
				{
					name: "is_active",
					col: 6,
				},
				{
					name: "name",
					sortable: "custom",
				},

				{
					name: "base_typ",
					sortable: "custom",
					col: 6,
				},
				{
					name: "valid_time",
					sortable: "custom",
					col: 6,
				},
				{
					name:"limit_value",
					col:6,
				},
				{
					name: "show_value",
					col: 6,
				},
				{
					name: "real_value",
					col: 6,
				},
				{
					name: "typ_in_user",
					col: 6,
				},
			],
		};
	},
};
</script>
<style lang="scss" scoped>
</style>
